import { RootState } from '../slices';

/**
 * The server owns and enforces the list of organizations allowed to leave the analysis warning text off of Truss
 * Design Drawings; this only decides whether to offer the option.
 */
export const canIgnoreTddErrors = (state: RootState) =>
  state.application.organizationCapabilities?.maySuppressAnalysisWarningsOnDrawings ?? false;
